import { render } from "./view-invoices.vue?vue&type=template&id=90291b4a&scoped=true"
import script from "./view-invoices.vue?vue&type=script&lang=js"
export * from "./view-invoices.vue?vue&type=script&lang=js"

import "./view-invoices.vue?vue&type=style&index=0&id=90291b4a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90291b4a"]])

export default __exports__